export enum CartModalKind {
	OrderError = "OrderError",
	OrderAlreadyExists = "OrderAlreadyExists",
	ClearForSubscription = "ClearForSubscription",
	ClearForProducts = "ClearForProducts",
	ClearForCourseOrder = "ClearForCourseOrder",
	ClearForPreorder = "ClearForPreorder",
	FfcMembersOnly = "FfcMembersOnly",
	VouchersRemoved = "VouchersRemoved",
}
